
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_684yf_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_684yf_1",
  "root": "awsui_root_mx3cw_684yf_119",
  "hidden": "awsui_hidden_mx3cw_684yf_157",
  "with-dismiss": "awsui_with-dismiss_mx3cw_684yf_202",
  "with-action": "awsui_with-action_mx3cw_684yf_202",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_684yf_208",
  "header": "awsui_header_mx3cw_684yf_215",
  "action": "awsui_action_mx3cw_684yf_219",
  "action-slot": "awsui_action-slot_mx3cw_684yf_224",
  "action-button": "awsui_action-button_mx3cw_684yf_225",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_684yf_229",
  "text": "awsui_text_mx3cw_684yf_255",
  "icon": "awsui_icon_mx3cw_684yf_260",
  "message": "awsui_message_mx3cw_684yf_263",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_684yf_271",
  "icon-size-big": "awsui_icon-size-big_mx3cw_684yf_274",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_684yf_277",
  "content": "awsui_content_mx3cw_684yf_281",
  "dismiss": "awsui_dismiss_mx3cw_684yf_285",
  "dismiss-button": "awsui_dismiss-button_mx3cw_684yf_290",
  "type-error": "awsui_type-error_mx3cw_684yf_294",
  "type-warning": "awsui_type-warning_mx3cw_684yf_302",
  "type-success": "awsui_type-success_mx3cw_684yf_310",
  "type-info": "awsui_type-info_mx3cw_684yf_318"
};
  